/**
 * List Routes
 */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Lista from "./components/Lista";
import Cadastro from "./components/Cadastro";
import Editar from "./components/Editar";

const Professional = ({ match }) => (
  <div className="content-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />
      <Route path={`${match.url}/list`} component={Lista} />
      <Route path={`${match.url}/cadastro`} component={Cadastro} />
      <Route path={`${match.url}/:id`} component={Editar} />
    </Switch>
  </div>
);

export default Professional;
